import { Modal } from 'react-bootstrap';
import { ExclamationTriangleFill, QuestionCircleFill } from 'react-bootstrap-icons';
import language from '../../data/language';
import { currentLanguage } from './notify';
import './ui.css';

/**
 * The replacement for window.confirm(). Destructive actions (delete a car,
 * delete a lead) route through this so the wording, the styling and the
 * "working…" state are the same everywhere.
 */
const ConfirmModal = ({
    show,
    title,
    message,
    detail,
    tone = "danger",
    confirmLabel,
    cancelLabel,
    loading = false,
    onConfirm,
    onCancel
}) => {
    const lang = currentLanguage();
    const strings = language[lang].common;

    return (
        <Modal show={show} centered size="md" onHide={loading ? undefined : onCancel} backdrop={loading ? "static" : true}>
            <div className="cx-confirm">
                <div className={`cx-confirm-icon cx-confirm-icon-${tone}`}>
                    {tone === "danger" ? <ExclamationTriangleFill /> : <QuestionCircleFill />}
                </div>
                <h4 className="cx-confirm-title">{title || strings.confirm_title}</h4>
                {message && <p className="cx-confirm-message">{message}</p>}
                {detail && <p className="cx-confirm-detail">{detail}</p>}
                <div className="cx-confirm-actions">
                    <button type="button" className="cx-btn cx-btn-ghost" disabled={loading} onClick={onCancel}>
                        {cancelLabel || strings.cancel}
                    </button>
                    <button
                        type="button"
                        className={`cx-btn ${tone === "danger" ? "cx-btn-danger" : "cx-btn-primary"}`}
                        disabled={loading}
                        onClick={onConfirm}
                    >
                        {loading
                            ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            : (confirmLabel || strings.confirm)}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default ConfirmModal;
